import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import {Menu, MenuItem} from '../../atoms/Menu';
import TranslatedText from '../../atoms/TranslatedText';
import i18n from '../../locales/i18n';

import './OakleyStealth.css';
import Video from '../../atoms/Video';

const SECTIONS = {
    hydrophobic: {
        title: 'oakley_stealth.hydrophobic.title',
        subtitle: 'oakley_stealth.hydrophobic.subtitle',
        labelLeft: 'oakley_stealth.hydrophobic.labelLeft',
        labelRight: 'oakley_stealth.hydrophobic.labelRight',
        video: require('./hydrophobic-video.mp4'),
        poster: require('./hydrophobic-video-poster.jpg'),
    },
    oleophobic: {
        title: 'oakley_stealth.oleophobic.title',
        subtitle: 'oakley_stealth.oleophobic.subtitle',
        labelLeft: 'oakley_stealth.oleophobic.labelLeft',
        labelRight: 'oakley_stealth.oleophobic.labelRight',
        video: require('./oleophobic-video.mp4'),
        poster: require('./oleophobic-video-poster.jpg'),
    },
    antireflection: {
        title: 'oakley_stealth.antireflection.title',
        subtitle: 'oakley_stealth.antireflection.subtitle',
        labelLeft: 'oakley_stealth.antireflection.labelLeft',
        labelLeftTop: 'oakley_stealth.antireflection.labelLeftTop',
        labelRightTop: 'oakley_stealth.antireflection.labelRightTop',
        labelRight: 'oakley_stealth.antireflection.labelRight',
        img: require('./anti-reflex.png'),
    },
};

export default class OakleyStealth extends PureComponent {
    state = {type: this.props.match.params.type, state: null};

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.type !== state.type) {
            return {type: props.match.params.type, state: null};
        }

        return null;
    }

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/OakleyStealth/${this.props.match.params.type}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/OakleyStealth/${this.props.match.params.type}`
        );
    }

    render() {
        const history = this.props.history;
        const type = this.props.match.params.type;
        const currentType = SECTIONS[type];

        let videoEl;
        let style;
        let caption;

        if (currentType.video) {
            videoEl = (
                <Video
                    className="OakleyStealth-video"
                    src={currentType.video}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${currentType.poster})`}}
                    autoPlay
                    muted
                    playsInline
                    loop
                />
            );
        } else {
            style = {
                background: `#000 url(${
                    currentType.img
                }) no-repeat center center`,
                backgroundSize: 'cover',
            };
        }

        if (currentType.labelRightTop) {
            caption = (
                <div className="OakleyStealth-center">
                    <span className="OakleyStealth-label OakleyStealth-label--with-line">
                        <TranslatedText tag={currentType.labelLeftTop} />
                    </span>
                    <span className="OakleyStealth-label OakleyStealth-label--with-line OakleyStealth-label--with-line--big">
                        <TranslatedText tag={currentType.labelRightTop} />
                    </span>
                </div>
            );
        }

        return (
            <article className="OkaleyStealth" style={style}>
                {videoEl}
                <div className="OakleyStealth-content">
                    <div className="OakleyStealth-top">
                        <h3 className="top-title">
                            <TranslatedText tag={currentType.title} />
                        </h3>
                        <h4 style={{marginTop: 0}}>
                            <TranslatedText tag={currentType.subtitle} />
                        </h4>
                    </div>
                    {caption}
                    <div className="OakleyStealth-bottom">
                        <span className="OakleyStealth-label">
                            <TranslatedText tag={currentType.labelLeft} />
                        </span>
                        <span className="OakleyStealth-label">
                            <TranslatedText tag={currentType.labelRight} />
                        </span>
                    </div>
                </div>

                <Menu>
                    <MenuItem
                        tag="oakley_stealth.hydrophobic.title"
                        onClick={() =>
                            history.push('/oakley-stealth/hydrophobic')
                        }
                        active={this.state.type === 'hydrophobic'}
                    />
                    <MenuItem
                        tag="oakley_stealth.oleophobic.title"
                        onClick={() =>
                            history.push('/oakley-stealth/oleophobic')
                        }
                        active={this.state.type === 'oleophobic'}
                    />
                    <MenuItem
                        tag="oakley_stealth.antireflection.title"
                        onClick={() =>
                            history.push('/oakley-stealth/antireflection')
                        }
                        active={this.state.type === 'antireflection'}
                    />
                </Menu>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/oakleyStealth/OakleyStealth.js